export default __webpack_public_path__ + "static/media/blog.79d97ac2.svg";